(function ( $ ) {

		$.fn.eventstagesline = function () {
			var $elem = $( this ),
				$stages = $elem.find( '.event-stage' ),
				$firstStage = $stages.first(),
				$lastStage = $stages.last(),
				$line = $elem.find( '.event-stages__line' );


			var init = function () {
					adjustLine();
					bindEvents();

				},
				bindEvents = function () {
					var debouncedAdjustLine = debounce( function () {
						adjustLine();
					}, 250 );

					window.addEventListener( 'resize', debouncedAdjustLine );
				},
				adjustLine = function () {
					if ( CAF.UTILS.areWeMobile() ) {

						// mobile
						var topPosition = $firstStage.position().top + ( $firstStage.outerHeight() / 2 ),
							bottomPosition = $elem.height() - $lastStage.position().top - ($lastStage.outerHeight() / 2) + 30; // 30 = half the bottom padding of the container

						$line.css( {
							left   : 23,
							right  : 'auto',
							top    : topPosition - 5, // plus half the bullet height
							bottom :bottomPosition ,
							height: 'auto',
							width: 3
						} );

					} else {

						//desktop
						var leftPosition = $firstStage.offset().left + ( $firstStage.outerWidth() / 2 ) - 5,
							rightPosition = $( window ).width() - $lastStage.offset().left - ($lastStage.outerWidth() / 2) - 5; //  = half the bullet width

						$line.css( {
							left   : leftPosition,
							right  : rightPosition,
							top    : 'auto', // default
							bottom : 25, // default: must mimick css,
							height: 3,
							width: 'auto'
						} );
					}

					$line.addClass('active');

				};

			init();
			return this;
		};

	}
	( $ )
)
;
